import { splitProductIds } from '../../reviews/helpers';
import { SELECTORS } from './constants';
import { SelectDropdownUI } from './ui';

export class SelectDropdown {
  static instances = [];

  constructor(container, onChange) {
    this.selectContainer = container.querySelector(`.${SELECTORS.DROPDOWN}`);
    this.nativeSelect = container.querySelector(`.${SELECTORS.NATIVE}`);
    this.ui = new SelectDropdownUI(container);
    this.onChange = onChange;

    SelectDropdown.instances.push(this);
  }

  getFirstOption = () => (
    this.nativeSelect.options[0]
  );

  getSelectedOption = () => (
    this.nativeSelect.options[this.nativeSelect.selectedIndex]
  );

  getPurposeOption = (value) => (
    [...this.nativeSelect.options].find((option) => Number(option.value) === Number(value)) || this.getFirstOption()
  );

  change = (defaultOption) => {
    this.ui.setDefaultOption(defaultOption || this.getSelectedOption());
  };

  init = (defaultOption) => {
    this.change(defaultOption);

    this.selectContainer.addEventListener('click', (e) => this.handleClickSelect(e));
    document.addEventListener('click', () => this.handleCloseOptions());
  };

  handleToggleOptions() {
    SelectDropdown.instances.forEach((instance) => {
      if (instance === this) {
        this.ui.toggleOptions();
      } else {
        instance.ui.hideOptions();
      }
    });
  }

  handleCloseOptions() {
    this.ui.hideOptions();
  }

  handleSelectCurrentOption(option) {
    this.ui.selectOption(option);
  }

  handleSelectOption(option) {
    const currentValue = option.getAttribute('data-value');

    this.nativeSelect.value = currentValue;

    this.ui.selectOption(option);
    this.handleCloseOptions();
    this.onChange?.(splitProductIds(currentValue));
  }

  handleClickSelect(event) {
    event.stopPropagation();

    const clickedOption = event.target.closest(`.${SELECTORS.OPTION}`);

    if (clickedOption) {
      this.handleSelectOption(clickedOption);
    } else {
      this.handleToggleOptions();
    }
  }
}
